// Precisión: se guardan instantes reales. El redondeo (ninguno | 15 min) se aplica solo al
// mostrar, exportar y escribir el total en Notion, y siempre sobre el total agregado.
// Debe coincidir con public.round_minutes() en SQL.

export type Rounding = 'ninguno' | '15min';

export const ROUNDING_OPTIONS: readonly { value: Rounding; label: string }[] = [
  { value: 'ninguno', label: 'Sin redondeo' },
  { value: '15min', label: 'Redondeo a 15 min' },
];

/** Minutos a mostrar para un total en segundos (redondeo al más cercano, mitades hacia arriba). */
export function roundMinutes(totalSeconds: number, rounding: Rounding): number {
  if (totalSeconds <= 0) return 0;
  if (rounding === '15min') return Math.round(totalSeconds / 900) * 15;
  return Math.round(totalSeconds / 60);
}

/** Horas con dos decimales a partir de minutos. */
export function minutesToHours(minutes: number): number {
  return Math.round((minutes / 60) * 100) / 100;
}

/** Valor que se escribe en `Horas trabajadas`. */
export function hoursForNotion(totalSeconds: number, rounding: Rounding): number {
  return minutesToHours(roundMinutes(totalSeconds, rounding));
}

/** Formato 'H:MM' (horas pueden superar 24). */
export function formatMinutes(minutes: number): string {
  const sign = minutes < 0 ? '-' : '';
  const abs = Math.abs(Math.round(minutes));
  return `${sign}${Math.floor(abs / 60)}:${String(abs % 60).padStart(2, '0')}`;
}

/** Formato decimal con coma (español), dos decimales. */
export function formatHours(hours: number | null): string {
  if (hours === null || Number.isNaN(hours)) return '';
  return hours.toFixed(2).replace('.', ',');
}
